import { Brick, registerBrick, WorkflowObjectState, Config } from 'olympe';
import { executeLambda } from "../../node/BackendData/LambdaExecutor";
import BCP from './DM_BCP';
import { getLogger } from "@olympeio/core";
import { getFormattedDate, getPersonName, getTargetBCPText, getNotAvailableText } from '../../web/section_sf/Utils.js';
import { EnvironmentMap, getCurrentVendorSite } from '../utils/CommonUtil.js';

export default class BCPRequestRejectionEmail extends Brick {

  /**
   * @override
   * @protected
   * @param {!BrickContext} $
   * @param {*} bCPRequest
   * @param {*} sendEmail
   * @param {function()} forwardEvent
   */
  async update($, [bCPRequest, workflowState, sendEmail], [forwardEvent]) {
    const webAppUrl = EnvironmentMap[Config.getParameter('ENV')] || '';
    const logger = getLogger('BCPRejectionNotification');
    logger.info("Rejection BCP request data", bCPRequest, workflowState);
    const riskAndCrisisDashboardUrl = "https://app.powerbi.com/groups/me/apps/7bf41880-7ece-4733-9181-6b6c720ddb08/reports/6c22dc90-b92d-4511-ae2a-32b2b5673927/ReportSection?ctid=12a3af23-a769-4654-847f-958f3d479f4a&experience=power-bi";

    const roles = [
      BCP.requestorProp,
      BCP.businessPartnerProp,
      BCP.procurementManagerProp,
      BCP.technicalApplicationGroupProp,
      BCP.qualityAssuranceProp,
      BCP.qaInFactoryProp,
    ];
    const parsedEmails = new Set();
    const parseNameEmail = (value) => {
      if (!value) return null; // Handle missing values gracefully
      const [name, email] = value.split(";").map((item) => item.trim());
      if (!name || !email) return null; // Ensure both name and email are valid
      return { name, email };
    };

    const joinNameDescription = (fieldId, fieldDesc) => {
      const id = bCPRequest.get(fieldId);
      const desc = bCPRequest.get(fieldDesc) ? ` - ${bCPRequest.get(fieldDesc)}` : '';
      return id ? `${id}${desc}` : 'No data';
    };


    // Construct email content
    const emailCont = async (name) => {
      let currentVendorSiteAndDescription;
            if (!bCPRequest.get(BCP.currentVendorSiteIdProp)) {
                currentVendorSiteAndDescription = await getCurrentVendorSite(bCPRequest, $)
            } else {
                currentVendorSiteAndDescription = bCPRequest.get(BCP.currentVendorSiteIdProp) + "-" + bCPRequest.get(BCP.currentVendorSiteDescriptionProp)
            }
            logger.info("BCPQAEmail:bCPRequest.get(BCP.currentVendorSiteIdProp)", bCPRequest.get(BCP.currentVendorSiteIdProp), bCPRequest.get(BCP.currentVendorSiteIdProp)?.length)
            logger.info(":::BCPQAEmail: currentVendorSiteAndDescription :::", currentVendorSiteAndDescription)
      return `
            <p>Hi, ${name}</p>
            <p>The below BCP requests has been rejected.</p>
            <table border="0" cellpadding="0" cellspacing="0" style="border-collapse: collapse;">
              <thead>
                <tr style="background-color: #f2f2f2;">
                  <th style="text-align: center; padding: 2px; border: 1px solid #ccc; width: 200px;">Plant</th>
                  <th style="text-align: center; padding: 2px; border: 1px solid #ccc; width: 250px;">Material</th>
                  <th style="text-align: center; padding: 2px; border: 1px solid #ccc; width: 200px;">Specification</th>
                  <th style="text-align: center; padding: 2px; border: 1px solid #ccc; width: 200px;">Main Vendor</th>
                  <th style="text-align: center; padding: 2px; border: 1px solid #ccc; width: 200px;">Current Vendor Site</th>
                  <th style="text-align: center; padding: 2px; border: 1px solid #ccc; width: 200px;">Requestor</th>
                  <th style="text-align: center; padding: 2px; border: 1px solid #ccc; width: 200px;">Request Date</th>
                  <th style="text-align: center; padding: 2px; border: 1px solid #ccc; width: 200px;">Main Vendor for Alternate Site</th>
                  <th style="text-align: center; padding: 2px; border: 1px solid #ccc; width: 200px;">Alternative Site</th>
                  <th style="text-align: center; padding: 2px; border: 1px solid #ccc; width: 200px;">Target BCP</th>
                  <th style="text-align: center; padding: 2px; border: 1px solid #ccc; width: 200px;">Priority</th>
                  <th style="text-align: center; padding: 2px; border: 1px solid #ccc; width: 200px;">Cost Savings</th>
                  <th style="text-align: center; padding: 2px; border: 1px solid #ccc; width: 200px;">Estimated Savings in CHF</th>
                  <th style="text-align: center; padding: 2px; border: 1px solid #ccc; width: 200px;">GHG Reduction</th>
                  <th style="text-align: center; padding: 2px; border: 1px solid #ccc; width: 200px;">Remarks</th>
                  <th style="text-align: center; padding: 2px; border: 1px solid #ccc; width: 200px;">Rejection Reason</th>
                  <th style="text-align: center; padding: 2px; border: 1px solid #ccc; width: 200px;">Rejected By</th>
                  <th style="text-align: center; padding: 2px; border: 1px solid #ccc; width: 200px;">Rejection Date</th>
                  <th style="text-align: center; padding: 2px; border: 1px solid #ccc; width: 200px;">Procurement Specialist</th>
                  <th style="text-align: center; padding: 2px; border: 1px solid #ccc; width: 200px;">Business Partner</th>
                  <th style="text-align: center; padding: 2px; border: 1px solid #ccc; width: 200px;">Procurement Manager</th>
                  <th style="text-align: center; padding: 2px; border: 1px solid #ccc; width: 200px;">CTAG</th>
                  <th style="text-align: center; padding: 2px; border: 1px solid #ccc; width: 200px;">SQA</th>
                  <th style="text-align: center; padding: 2px; border: 1px solid #ccc; width: 200px;">QA in Factory</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style="padding: 2px; border: 1px solid #ccc;">${joinNameDescription(BCP.plantIdProp, BCP.plantDescriptionProp)}</td>
                  <td style="padding: 2px; border: 1px solid #ccc;">${joinNameDescription(BCP.materialIdProp, BCP.materialDescriptionProp)}</td>
                  <td style="padding: 2px; border: 1px solid #ccc;">${bCPRequest.get(BCP.specificationProp) || getNotAvailableText()}</td>
                  <td style="padding: 2px; border: 1px solid #ccc;">${joinNameDescription(BCP.mainVendorIdProp, BCP.mainVendorDescriptionProp)}</td>
                  <td style="padding: 2px; border: 1px solid #ccc;">${currentVendorSiteAndDescription}</td>
                  <td style="padding: 2px; border: 1px solid #ccc;">${getPersonName(bCPRequest.get(BCP.requestorProp))?.fullName || getNotAvailableText()}</td>
                  <td style="padding: 2px; border: 1px solid #ccc;">${getFormattedDate(bCPRequest.get(BCP.requestDateProp)) || getNotAvailableText()}</td>
                  <td style="padding: 2px; border: 1px solid #ccc;">${bCPRequest.get(BCP.mainVendorLinkedAltVendorProp) || getNotAvailableText()}</td>
                  <td style="padding: 2px; border: 1px solid #ccc;">${bCPRequest.get(BCP.alternativeVendorCodeProp) || getNotAvailableText()}</td>
                  <td style="padding: 2px; border: 1px solid #ccc;">${getTargetBCPText(bCPRequest.get(BCP.targetBCPProp)) || getNotAvailableText()}</td>
                  <td style="padding: 2px; border: 1px solid #ccc;">${bCPRequest.get(BCP.priorityProp) || getNotAvailableText()}</td>
                  <td style="padding: 2px; border: 1px solid #ccc;">${bCPRequest.get(BCP.costSavingsProp) || getNotAvailableText()}</td>
                  <td style="padding: 2px; border: 1px solid #ccc;">${bCPRequest.get(BCP.inputSavingEstimatesProp) || getNotAvailableText()}</td>
                  <td style="padding: 2px; border: 1px solid #ccc;">${bCPRequest.get(BCP.ghgReductionProp) || getNotAvailableText()}</td>
                  <td style="padding: 2px; border: 1px solid #ccc;">${bCPRequest.get(BCP.remarkProp) || getNotAvailableText()}</td>
                  <td style="padding: 2px; border: 1px solid #ccc;color:red;">${bCPRequest.get(BCP.rejectedNoteProp) || getNotAvailableText()}</td>
                  <td style="padding: 2px; border: 1px solid #ccc;">${workflowState.get(WorkflowObjectState.assigneeProp) || getNotAvailableText()}</td>
                  <td style="padding: 2px; border: 1px solid #ccc;">${getFormattedDate(workflowState.get(WorkflowObjectState.dateTimeProp)) || getNotAvailableText()}</td>
                  <td style="padding: 2px; border: 1px solid #ccc;">${getPersonName(bCPRequest.get(BCP.procurementSpecialistProp))?.fullName || getNotAvailableText()}</td>
                  <td style="padding: 2px; border: 1px solid #ccc;">${getPersonName(bCPRequest.get(BCP.businessPartnerProp))?.fullName || getNotAvailableText()}</td>
                  <td style="padding: 2px; border: 1px solid #ccc;">${getPersonName(bCPRequest.get(BCP.procurementManagerProp))?.fullName || getNotAvailableText()}</td>
                  <td style="padding: 2px; border: 1px solid #ccc;">${getPersonName(bCPRequest.get(BCP.technicalApplicationGroupProp))?.fullName || getNotAvailableText()}</td>
                  <td style="padding: 2px; border: 1px solid #ccc;">${getPersonName(bCPRequest.get(BCP.qualityAssuranceProp))?.fullName || getNotAvailableText()}</td>
                  <td style="padding: 2px; border: 1px solid #ccc;">${getPersonName(bCPRequest.get(BCP.qaInFactoryProp))?.fullName || getNotAvailableText()}</td>
                </tr>
              </tbody>
            </table>
            <p>To have full visibility of BCP requests, please use the <a href="${riskAndCrisisDashboardUrl}">BCP request view in the Risk & Crisis Dashboard</a>.</p>
            <p>Please follow this link to access the <a href="${webAppUrl}">Risk & Crisis App</a></p>
            <p>Please do not reply to this email as this is an automatically generated notification</p>
            <p>Thank you for your collaboration.</p>
            <p>Your Ensuring Supply Team</p>`;
    };



    for (const role of roles) {
      const stakeholderData = bCPRequest.get(role); // Check if the field exists

      if (!stakeholderData) {
        logger.info(`Field ${role} is missing in the input object.`);
        continue; // Skip this stakeholder if the field is missing
      }

      const parsedData = parseNameEmail(stakeholderData);

      if (!parsedData) {
        logger.info(`Invalid data for ${role}:`, stakeholderData);
        continue; // Skip to the next role if parsing fails
      }

      const { name, email } = parsedData;

      // Skip duplicate emails
      if (parsedEmails.has(email)) {
        logger.info(`Duplicate email found: ${email}, skipping email send.`);
        continue;
      }

      // Add email to the Set to track
      parsedEmails.add(email);

      // Generate email content
      const emailContent = await emailCont(name);
      logger.info("Rejection email emailContent", emailContent)
      try {
        const bodyResult = await executeLambda($, sendEmail, [email, emailContent]);
        logger.info("Email sent successfully:", bodyResult);
      } catch (error) {
        logger.error("Error sending email:", error);
      }
    }

    forwardEvent();
  }

}

registerBrick('01942757ef043e91ed58', BCPRequestRejectionEmail);
